import EnumFontWeight = DisguiseDto.EnumFontWeight;

export class FontService {

  getFontWeight(fontWeight: EnumFontWeight | undefined) {
    if (!fontWeight) {
      return '';
    }
    switch (fontWeight) {
      case 'LIGHT':
        return 'font-weight-thin';
      case 'THIN':
        return 'font-weight-light';
      case 'REGULAR':
        return 'font-weight-regular';
      case 'MEDIUM':
        return 'font-weight-medium';
      case 'BOLD':
        return 'font-weight-bold';
      case 'BLACK':
        return 'font-weight-black';
    }
  }
}

const FONT_SERVICE_INSTANCE = new FontService();

export {FONT_SERVICE_INSTANCE};
